module.exports = __webpack_public_path__ + "static/media/neeraj.5f22e031.jpeg";